// todo: translate these (generated on API at the moment)
export const BooleanStrings = {
  yes: 'Yes',
  no: 'No',
  translatedYes: $localize`Yes`,
  translatedNo: $localize`No`,
};
